module.exports = function(cb) {
	require.ensure([], function(require) {
		cb(require("!!../../../../../../node_modules/.pnpm/babel-loader@8.4.1_@babel+core@7.29.7_webpack@5.111.1/node_modules/babel-loader/lib/index.js??ruleSet[1].rules[0].use[0]!./index.js"));
	});
}